module.exports = __webpack_public_path__ + "img/mid.c6c3595e.jpg";